import { generateMedia } from "styled-media-query";

const size = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
  xxxl: '1960px',
};

export const customMedia = generateMedia(size);

export const breakpoints = {
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  xxxl: `(min-width: ${size.xxxl})`,
};
